import { render } from "./ReportList.vue?vue&type=template&id=51c240fa&ts=true"
import script from "./ReportList.vue?vue&type=script&lang=ts"
export * from "./ReportList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__